// Exports: StatusBadge
import React from "react";
import clsx from "clsx";

const StatusBadge = ({ value }) => {
  const badgeClass =
    value === "Ongoing" || value === "Medium"
      ? "text-yellow-800 bg-yellow-100"
      : value === "Completed" || value === "Complete" || value === "Low"
        ? "text-green-800 bg-green-100"
        : value === "Overdue" || value === "High" || value === "Halted"
          ? "text-red-800 bg-red-100"
          : "text-gray-800 bg-gray-100";

  return (
    <span
      className={clsx(
        "px-2 xl:px-4 py-1 rounded-md items-center w-full font-normal text-xs xl:text-sm flex flex-row justify-center hover:bg-gray-200",
        badgeClass
      )}
      style={{
        gap: "0.5rem",
      }}
    >
      {value}
    </span>
  );
};

export default StatusBadge;
